
import * as Li9za2lrby5tanM from './skiko.mjs';
import * as _ref_QGZpcmViYXNlL2F1dGg_ from '@firebase/auth';
import * as _ref_QGpzLWpvZGEvY29yZQ_ from '@js-joda/core';
import * as _ref_ZmlyZWJhc2UvYXBw_ from 'firebase/app';
import { instantiate } from './composeApp.uninstantiated.mjs';

const exports = (await instantiate({
    './skiko.mjs': Li9za2lrby5tanM,
    '@firebase/auth': _ref_QGZpcmViYXNlL2F1dGg_,
    '@js-joda/core': _ref_QGpzLWpvZGEvY29yZQ_,
    'firebase/app': _ref_ZmlyZWJhc2UvYXBw_
})).exports;

export default new Proxy(exports, {
    _shownError: false,
    get(target, prop) {
        if (!this._shownError) {
            this._shownError = true;
            throw new Error("Do not use default import. Use the corresponding named import instead.")
        }
    }
});
export const {
    _initialize,
    memory
} = exports;

